//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			show: false,
			button: null,
			buttonObject: null,
		};
	},

	props: {
		title: {},
		buttonLabel: {},
		buttonUrl: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {
		this.buttonObject = JSON.parse(this.buttonUrl);
	},
};



// WEBPACK FOOTER //
// ./scripts/vue/SubscribeBanner.vue